import React from 'react';
import { Container } from '../components/ui/Primitives';
import { Button } from '../components/ui/Button';
import { Seo } from '../components/Seo';
export function NotFound() {
  return <Container className="py-24 text-center sm:py-32" data-id="element-1150" data-mp="1064jkbqpaafd">
      <Seo title="Page not found" description="We cannot find that page. Our services, insights and resources are reachable from the main navigation." path="/404" noIndex data-id="element-1151" data-mp="104jo8jwkangg" />
      <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-1152" data-mp="1a1y4ojihjc8r">Page not found</p>
      <h1 className="mt-4 font-display text-[34px] leading-tight text-ink sm:text-[44px]" data-id="element-1153" data-mp="1f112pk01si78">
        We cannot find that page
      </h1>
      <p className="mx-auto mt-5 max-w-md text-[16px] text-body" data-id="element-1154" data-mp="1nvyu2mnjrmwg">
        The link may be out of date. Our services, insights and resources are all reachable from the main
        navigation.
      </p>
      <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-1155" data-mp="1xt3hsqx1jqfd">
        <Button to="/" data-id="element-1156" data-mp="1nvu9cz1n642f">Back to the home page</Button>
        <Button to="/insights" variant="secondary" data-id="element-1157" data-mp="1nxf3ink1nkzr">Read our insights</Button>
      </div>
    </Container>;
}